export const services = [
  {
    key: "teammate",
    image: "/assets/img/teammate.png",
    link: "/news/teammate--audit-management-solution"
  },
  {
    key: "teammate-analytics",
    image: "/assets/img/teammateanalytics.png",
    link: "/news/teammate-analytics-for-audit"
  },
  {
    key: "envizi",
    image: "/assets/img/envizi.png",
    link: "/news/ibm-envizi-esg-suite"
  },
  {
    key: "knk",
    image: "/assets/img/knk.png",
    link: "/news/greentrack----greenhouse-gas-emissions-inventory-services"
  },
  {
    key: "zeroboard",
    image: "/assets/img/zeroboard.png",
    link: "/news/zeroboard--ghg-calculation---visualization-"
  }
];

export const partners = [
  {
    name: "CGS VIETNAM",
    image_url: "assets/img/cgs_logo.png",
    url: "https://cgsvietnam.com"
  },
  {
    name: "ENVIZI",
    image_url: "assets/img/envizi_logo.png",
    url: "https://www.ibm.com/products/envizi"
  },
  {
    name: "Wolters Kluwer",
    image_url: "assets/img/wk_logo.png",
    url: "https://www.wolterskluwer.com"
  },
  {
    name: "IBM",
    image_url: "assets/img/ibm_logo.png",
    url: "https://www.ibm.com"
  },
  {
    name: "TRUEBPM",
    image_url: "assets/img/truebpm_logo.png",
    url: "https://www.truebpm.vn"
  },
  {
    name: "The Institute of Internal Auditors Viet Nam",
    image_url: "assets/img/iia.png",
    url: "https://theiia-vietnam.org/"
  },
  {
    name: "Zeroboard",
    image_url: "assets/img/zeroboard.png",
    url: "https://www.zeroboard.jp/"
  }
];

export const customers = [
  {
    name: "BIDV",
    image_url: "/assets/img/bidv_logo.png",
    url: "https://www.bidv.com.vn/"
  },
  {
    name: "ENV",
    image_url: "/assets/img/evn_logo.png",
    url: "https://www.evn.com.vn/"
  },
  {
    name: "TP Bank",
    image_url: "/assets/img/tpbank.png",
    url: "https://tpb.vn/"
  },
  {
    name: "MB Bank",
    image_url: "/assets/img/mbbank.png",
    url: "https://www.mbbank.com.vn/"
  },
  {
    name: "FE CREDIT",
    image_url: "/assets/img/fe_logo.png",
    url: "https://www.fecredit.com.vn/"
  },
  {
    name: "Vinamilk",
    image_url: "/assets/img/vinamilk.png",
    url: "https://www.vinamilk.com.vn/"
  },
  {
    name: "Saigon Newport Corp.(SNP)",
    image_url: "/assets/img/SNP1.png",
    url: "https://saigonnewport.com.vn/"
  }
];

export const teamMembers = [
  {
    key: "thai",
    image_url: "/assets/img/thai_nguyen.jpg"
  },
  {
    key: "thinh",
    image_url: "/assets/img/thinh_nguyen.jpg"
  },
  {
    key: "trung",
    image_url: "/assets/img/trung_le.jpg"
  },
  {
    key: "hung",
    image_url: "/assets/img/hung_hoang.jpg"
  },
  {
    key: "stephen",
    image_url: "/assets/img/stephen_coates.jpg"
  }
];
